import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { useWidth } from "@/utils/resize";
import { useEffect, useState } from "react";
import buriedsdk from "@/utils/zz-buried/index";
import { getCookie } from "cookies-next";

type Props = {
  list: any[]
};
const Index = (props: Props) => {
  const { width, display } = useWidth();
  const { t, i18n } = useTranslation("features");
  const [offset, setOffset] = useState(200);
  const [show, setShow] = useState(true);
  const list = props.list;

  const btnClick = (btnWords, type ,item) => {
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `${btnWords || 'Get started'}按钮`,
      URL: process.env.publicApiDomain,
    });
    if(item){
      setTimeout(() => {
        window.open(width > 1024 ? item.pcUrl : item.mUrl, "_blank")
      }, 500);
    }
  };
  useEffect(() => {
    let token = getCookie("authorized-token") as string;
    let data = (token ? JSON.parse(token) : token) as any;
    const openPageView = false;
    buriedsdk.init(
      13,
      process.env.envType === "production" ? "prod" : "test",
      token ? data.accessToken : undefined,
      openPageView
    );
  }, []);
  return (
    <div className={`bg-[#fff] productMatrix ${styles.productMatrix}`}>
      <div className={styles["productMatrix-content"]}>
        <div className={`${styles["ys-wrapper"]}`} id="ys">
          <div className={`${styles["ys-list"]}`}>
            {list.map((el, index) => {
              return (
                <div
                  className={`${styles["pro-module-item"]}`}
                  style={{ background: el.bg }}
                  key={index}
                >
                  <div
                    className={`${styles["pro-module-wrapper"]} animate-box`}
                  >
                    <div className={`${styles["pro-module-content"]}`}>
                      <h3 className={`${styles["pro-module-item-title"]} ant`}>
                        {el.title}
                      </h3>
                      {el.title2 && <h4 className={`${styles["pro-module-item-title"]} ant`}>
                        {el.title2}
                      </h4>}
                      <sub className={`${styles["pro-module-item-tip"]} ant`}>
                        {el.tip}
                      </sub>
                      <a
                        className={`${styles["pro-module-btn"]} ant`}
                        href={width > 1024 ? el.pcUrl : el.mUrl}
                        onClick={(e) => {
                          e.preventDefault()
                          btnClick(el.btnWords || 'Get started', "shoplus", el);
                        }}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t(el.btnWords || "Get started")}
                      </a>
                    </div>
                    <div className={`${styles["pro-module-img"]} ant`}>
                      <Image
                        alt={el.alt}
                        src={el.img}
                      ></Image>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Index;